export default {
    "stage_date_end_included": false,
    "types": {
        "plan": {
            "showName": "Постановка целей",
            "selected": false,
            "order": 1,
            "autostart": false,
            "canManageElementsBeforeDateStart": false,
            "canManageElementsAfterDateEnd": false,
            "hideDates": false,
            "showNegotiationsDates": false
        },
        "correction": {
            "showName": "Корректировка целей",
            "selected": false,
            "order": 2,
            "canManageElementsBeforeDateStart": false,
            "canManageElementsAfterDateEnd": false,
            "canBeAddedDynamically": true,
            "hideDates": false,
            "showNegotiationsDates": false
        },
        "intermediate_assessment": {
            "showName": "Промежуточная оценка",
            "selected": false,
            "order": 3,
            "canManageElementsBeforeDateStart": false,
            "canManageElementsAfterDateEnd": false,
            "hideDates": false,
            "showNegotiationsDates": false
        },
        "assessment": {
            "showName": "Подведение итогов",
            "selected": false,
            "order": 4,
            "canManageElementsBeforeDateStart": false,
            "canManageElementsAfterDateEnd": false,
            "hideDates": false,
            "showNegotiationsDates": false
        }
    },
    "card_stages_block_template": null
}